import React, { useState, useEffect, useContext, useCallback, useRef } from 'react';
import { Dropdown } from 'react-bootstrap';
import styles from './TreeView.module.css';
import { fetchTopicsSubTopics, renameSubtopic, deleteTopic, deleteSubTopic, addTopic, addSubtopicToTopic, 
         addIndexSubtopic } from '../../../../../../services/LingvoSemanticAPI'
import { TopicsSubTopicsContext, WhatSelected } from '../../../../context/TopicsSubTopics';
import { randomString } from '../../../../../../utils/text';
import { nodeIsSelected } from './utils' 

const TreeView = () => {

  const wasInitRef = useRef(false);

  const {
      whatSelected, setWhatSelected,
      setErrorTopicsSubTopics,  
      selectedTopicOrSubtopicIndex, setselectedTopicOrSubtopicIndex,
      setIsLoadingTopicsSubTopics,
      setSelectedTopicOrSubtopicName
  } = useContext(TopicsSubTopicsContext);

  const [treeData, setTreeData] = useState([]);
  
  //const [rootSelected, setRootSelected] = useState(false); // id у топиков и суб-топиков могут быть одинаковыми, нужно снимать выделение с отстальных при выборе одного

  const loadTopicsSubTopics = useCallback(async () => {
      //setIsLoadingTopicsSubTopics(true);

      const parseLabel = (label) => {
        if (!label || label === '[]') return [0];
        const match = label.match(/\[(.*?)\]/);
        if (!match) return [0];
        return match[1]
          .split('.')
          .map(num => (isNaN(Number(num)) ? 0 : Number(num)));
      };

      const compareDesc = (a, b) => {
        const aParts = parseLabel(a);
        const bParts = parseLabel(b);

        const len = Math.max(aParts.length, bParts.length);
        for (let i = 0; i < len; i++) {
          const aVal = aParts[i] ?? 0;
          const bVal = bParts[i] ?? 0;
          if (aVal !== bVal) {
            return bVal - aVal; // по убыванию
          }
        }
        return 0;
      };

      try {
        const data = await fetchTopicsSubTopics();
        const transformed = data.map(topic => ({
          id: topic.id,
          label: topic.name,
          collapsed: false,
          root: true,
          children: topic.subtopics.map(sub => ({
            id: sub.id,
            label: `[${sub.index}] ${sub.name}`,
            collapsed: false,
            root: false,
            children: [],
          })).sort((a, b) => -1 * compareDesc(a.label, b.label))
        }));
        setTreeData(transformed);
        //setErrorTopicsSubTopics(null);
      } catch (error) {
        //setErrorTopicsSubTopics(`Ошибка загрузки топиков: ${error.message}`);
        console.log(`Ошибка загрузки топиков: ${error.message}`);
      } finally {
        //setIsLoadingTopicsSubTopics(false);
      }
  });

  // Загрузка топиков при монтировании компонента
  useEffect(() => {
      console.log('useEffect called with loadTopicsSubTopics');
      if (!wasInitRef.current) {
        loadTopicsSubTopics();
        wasInitRef.current = true;
        console.log('wasInitRef', wasInitRef);
      }
  }, []);

  const [selectedId, setSelectedId] = useState(null);
  const [contextNodeId, setContextNodeId] = useState(null);
  const [menuPosition, setMenuPosition] = useState(null);
  const [editingNodeId, setEditingNodeId] = useState(null);
  const [tempLabel, setTempLabel] = useState('');

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      console.log(`Скопировано в буфер: ${text}`);
    } catch (err) {
      console.error('Ошибка копирования:', err);
    }
  };

  const handleLeftClick = async (e, nodeId) => {
    e.stopPropagation();
    setSelectedId(nodeId);
    if (e.target.tagName === 'LI') {
        const clickedItem = e.target;
        let text = '';
        clickedItem.childNodes.forEach(node => {
            if (node.nodeType === Node.TEXT_NODE) {
                text += node.textContent.trim();
            }
        });
        setSelectedTopicOrSubtopicName(text);
        await copyToClipboard(text);
        console.log('Treee -> nodeId', nodeId);
        setselectedTopicOrSubtopicIndex(nodeId);
        if (e.target.getAttribute('root') === "true"){
          setWhatSelected(WhatSelected.TOPIC);
        } else {
          setWhatSelected(WhatSelected.SUBTOPIC);
        }
        console.log('whatSelected', whatSelected);
    }
    setMenuPosition(null);
  };

  const handleRightClick = (e, nodeId) => {
    e.preventDefault();
    e.stopPropagation();
    setSelectedId(nodeId);
    setContextNodeId(nodeId);
    setMenuPosition({ x: e.pageX, y: e.pageY });
  };

  const toggleCollapse = (e, id) => {
    e.stopPropagation();
    setTreeData((prev) => toggleNodeCollapse(prev, id));
  };

  const addChild = async () => {

    if (contextNodeId == null) return;

    try {
      const rndName = randomString(16);
      const newSubTopic = await addSubtopicToTopic(contextNodeId, rndName);
      setTreeData((prev) => {
        const { updated, addedId } = addChildToTree(prev, contextNodeId, newSubTopic.id);
        setSelectedId(addedId);
        setEditingNodeId(addedId);
        setTempLabel('');
        setMenuPosition(null);
        return updated;
      });
    } catch (error) {
        console.log(error);
        setErrorTopicsSubTopics(`Ошибка при добавление суб-интереса: ${error}`);
    } finally {
    }
  };

  const removeNode = async () => {
    if (contextNodeId == null) return;
    try {
      console.log('removeNode', whatSelected);
      switch (whatSelected) {
        case WhatSelected.TOPIC: {
          await deleteTopic(contextNodeId);
          console.log(whatSelected, 'contextNodeId', contextNodeId);
          break;
        }
        case WhatSelected.SUBTOPIC: {
          await deleteSubTopic(contextNodeId);
          console.log(whatSelected, 'contextNodeId', contextNodeId);
          break;
        }
      }
      setTreeData((prev) => removeNodeFromTree(prev, contextNodeId));
      setMenuPosition(null);
      if (selectedId === contextNodeId) {
        setSelectedId(null);
      }
    } catch (error) {
        console.log(error);
        setErrorTopicsSubTopics(`Ошибка при удалении интереса/суб-интереса: ${error}`);
    } finally {

    }
  };

  const handleLabelSave = async (id) => {
    const newLabel = tempLabel.trim();
    try {
      const newSubTopic = await renameSubtopic(id, newLabel);
      setTreeData((prev) =>
        updateNodeLabel(prev, id, `[] ${newLabel}`)
      );
      setEditingNodeId(null);
      setTempLabel('');
    } catch (error) {
        console.log(error);
        setErrorTopicsSubTopics(`Ошибка при добавление суб-интереса: ${error}`);
    } finally {
    }
  };

  const addIndex = async () => {
    console.log(selectedTopicOrSubtopicIndex);
    const newIndex = prompt('Введите индекс:');
    try {
      const updatedSubTopic = await addIndexSubtopic(selectedTopicOrSubtopicIndex, newIndex);
      setTreeData((prev) =>
        updateNodeLabel(prev, selectedTopicOrSubtopicIndex, `[${newIndex}] ${updatedSubTopic.name}`)
      );
      setEditingNodeId(null);
      setTempLabel('');
    } catch (error) {
        console.log(error);
        setErrorTopicsSubTopics(`Ошибка при добавление индекса у суб-интереса: ${error}`);
    } finally {
    }
  }

  const addRootNode = async () => {
    
    const label = prompt('Введите имя интереса:', `Любое слово`);
    if (!label) return;

    try {
      const newTopic = await addTopic(label);
      const newNode = {
        id: newTopic.id,
        label,
        children: [],
        collapsed: false,
        root: true
      };
      setTreeData((prev) => [...prev, newNode]);
      setselectedTopicOrSubtopicIndex(-1);
      setSelectedTopicOrSubtopicName('');
    } catch (error) {
        console.log(error);
        setErrorTopicsSubTopics(`Ошибка при добавление интереса: ${error}`);
    } finally {
      setMenuPosition(null);
    }
  };

  const renderTree = (nodes, parent = null) => (
    <ul className='list-unstyled' style={{ marginLeft: parent === null ? '0' : '18px'}}>
      {nodes.map((node) => (
        <li
          key={node.id}
          root={node.root.toString()}
          onClick={(e) => handleLeftClick(e, node.id)}
          onContextMenu={(e) => handleRightClick(e, node.id)}
          style={{
            cursor: 'pointer',
            padding: '4px',
            margin: '0',  //,
            borderRadius: '4px',
            color: styles.textWhite,
            textAlign: 'left'
          }}
          //className={`${styles.treeNode} ${ nodeIsSelected() selectedId === node.id && (whatSelected.TOPIC === 'topic' && ) ? styles.selected : ''}`}
          className={`${styles.treeNode} ${ nodeIsSelected(node.id, node.root.toString(), selectedId, whatSelected)? styles.selected : ''}`}
        >
          {node.children.length > 0 && (
            <span
              onClick={(e) => toggleCollapse(e, node.id)}
              style={{ marginRight: '8px', cursor: 'pointer', userSelect: 'none' }}
            >
              {node.collapsed ? '➕' : '➖'}
            </span>
          )}
          {editingNodeId === node.id ? (
            <input
              autoFocus
              type="text"
              value={tempLabel}
              onChange={(e) => setTempLabel(e.target.value)}
              onBlur={() => handleLabelSave(node.id)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleLabelSave(node.id);
                }
              }}
              style={{ marginLeft: 4 }}
            />
          ) : (
            node.label
          )}
          {!node.collapsed && node.children.length > 0 && renderTree(node.children, node)}
        </li>
      ))}
    </ul>
  );

  const handleClickOutside = () => {
    setMenuPosition(null);
    setSelectedTopicOrSubtopicName('');
    setselectedTopicOrSubtopicIndex(-1);
    setWhatSelected(WhatSelected.NOTHING);
  };

  const isRootNode = (id) => {
    return treeData.some((node) => node.id === id);
  };

  return (
    <div className={`${styles.modeDarkBorder} p-3`}
      onClick={() => {
        setSelectedId(null);
        setContextNodeId(null);
        setMenuPosition(null);
        handleClickOutside();
      }}
      onContextMenu={(e) => {
        e.preventDefault();
        setSelectedId(null);
        setContextNodeId(null);
        setMenuPosition({ x: e.pageX, y: e.pageY });
      }}
      style={{ userSelect: 'none', backgroundColor: 'rgb(34, 37, 41)' }}
    >
      {/* <h4 className={styles.textWhite}>TreeView</h4> */}

      {renderTree(treeData)}

      {menuPosition && (
        <Dropdown show style={{ position: 'absolute', top: menuPosition.y, left: menuPosition.x }}>
          <Dropdown.Menu show className={styles.contextMenu}>
            {contextNodeId === null ? (
              <Dropdown.Item onClick={addRootNode}>➕ Добавить корневой узел</Dropdown.Item>
            ) : isRootNode(contextNodeId) ? (
              <>
                <Dropdown.Item onClick={addChild}>➕ Добавить дочерний узел</Dropdown.Item>
                <Dropdown.Item onClick={removeNode}>🗑 Удалить узел</Dropdown.Item>
              </>
            ) : (
              <>
                <Dropdown.Item onClick={addIndex}>➕ Добавить индекс</Dropdown.Item>
                <Dropdown.Item onClick={removeNode}>🗑 Удалить узел</Dropdown.Item>
              </>
            )}
          </Dropdown.Menu>
        </Dropdown>
      )}
    </div>
  );
};

// === Utility Functions ===
function addChildToTree(nodes, targetId, newId) {
  let addedId = null;
  const updated = nodes.map((node) => {
    if (node.id === targetId) {
      const newChild = {
        id: newId,
        label: '',
        root: false,
        children: [],
        collapsed: false,
      };
      addedId = newChild.id;
      return {
        ...node,
        collapsed: false,
        children: [...node.children, newChild],
      };
    } else if (node.children.length > 0) {
      // const { updated: childrenUpdated, addedId: childAddedId } = addChildToTree(node.children, targetId, newId);
      // if (childAddedId !== null) addedId = childAddedId;
      // return {
      //   ...node,
      //   children: childrenUpdated,
      // };
    }
    return node;
  });

  return { updated, addedId };
}

function removeNodeFromTree(nodes, targetId) {
  return nodes
    .filter((node) => node.id !== targetId)
    .map((node) => ({
      ...node,
      children: removeNodeFromTree(node.children, targetId),
    }));
}

function toggleNodeCollapse(nodes, targetId) {
  return nodes.map((node) => {
    if (node.id === targetId) {
      return { ...node, collapsed: !node.collapsed };
    } else if (node.children.length > 0) {
      return { ...node, children: toggleNodeCollapse(node.children, targetId) };
    }
    return node;
  });
}

function updateNodeLabel(nodes, id, newLabel) {
  return nodes.map((node) => {
    if (node.id === id) {
      return { ...node, label: newLabel };
    } else if (node.children.length > 0) {
      return { ...node, children: updateNodeLabel(node.children, id, newLabel) };
    }
    return node;
  });
}

export default React.memo(TreeView); // чтобы не вызывать useEffect многое количество раз
